import { fromJS, Set } from 'immutable'
import * as actionTypes from './constants'
import {
  SUBSCRIBE_NOTIFICATION,
  UNSUBSCRIBE_NOTIFICATION
} from '../PlanSelection/constants'
import { LOGOUT } from '../authentication/constants'

const initialState = fromJS({
  subscriptions: [],
  emailFrequency: '',
  notifications: {
    page: 0,
    totalPages: 0
  }
})

function notificationReducer(state = initialState, action) {
  switch (action.type) {
    // Notification Frequency
    case actionTypes.GET_EMAIL_FREQUENCY_DONE: {
      return state.set('emailFrequency', action.emailFrequency)
    }
    case actionTypes.UPDATE_EMAIL_FREQUENCY_ERROR: {
      return state.set('emailFrequencyError', action.error)
    }
    // Subscriptions
    case actionTypes.GET_SUBSCRIPTIONS_DONE: {
      return state.set(
        'subscriptions',
        new Set(action.subscriptions.map((subscription) => subscription.id))
      )
    }
    case actionTypes.GET_SUBSCRIPTIONS_ERROR: {
      return state.set('subscriptionsError', action.error)
    }
    case actionTypes.TOGGLE_SUBSCRIPTION_DONE: {
      const subscriptions = action.isSubscribed
        ? state.get('subscriptions').delete(action.subscriptionDetails.id)
        : state.get('subscriptions').add(action.subscriptionDetails.id)
      return state.set('subscriptions', subscriptions)
    }
    case SUBSCRIBE_NOTIFICATION: {
      return state.set(
        'subscriptions',
        state.get('subscriptions').union(action.ids)
      )
    }
    case UNSUBSCRIBE_NOTIFICATION: {
      return state.set(
        'subscriptions',
        state.get('subscriptions').subtract(action.ids)
      )
    }
    // Notifications
    case actionTypes.SET_NOTIFICATIONS_PAGE: {
      return state.setIn(['notifications', 'page'], action.page)
    }
    case actionTypes.CHECK_UNREAD_NOTIFICATIONS_DONE: {
      return state.set('hasUnreadNotifications', action.status)
    }
    case actionTypes.GET_NOTIFICATIONS:
      return state
        .set('gettingNotificationsPage', true)
        .delete('getNotificationError')
    case actionTypes.GET_NOTIFICATIONS_ERROR:
      return state
        .set('gettingNotificationsPage', false)
        .set('getNotificationError', action.error)
    case actionTypes.GET_NOTIFICATIONS_DONE: {
      const notificationContent = {
        [action.notifications.number]: action.notifications.content,
        totalElements: action.notifications.totalElements,
        totalPages: action.notifications.totalPages,
        page: action.notifications.number
      }

      return state
        .set('gettingNotificationsPage', false)
        .set(
          'notifications',
          action.notifications.number > 0
            ? state.get('notifications').merge(fromJS(notificationContent))
            : fromJS(notificationContent)
        )
    }

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default notificationReducer
